import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=40a11c67"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=40a11c67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports